import { render, staticRenderFns } from "./WorkHoursDetailedTable.vue?vue&type=template&id=57ff6dd1"
import script from "./WorkHoursDetailedTable.vue?vue&type=script&lang=js"
export * from "./WorkHoursDetailedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports